import { FCX } from "@datassential/platform-ui-lib";
import { IoIosArrowForward } from "react-icons/io";
import cn from "classnames";
import { useMemo, useState } from "react";
import { FaLock } from "react-icons/fa";
import "./AccessLink.scss";

const AccessLink: FCX<{
    url: string | null;
    text: string;
    altText?: string;
    hasAccess?: boolean;
    hideArrowIcon?: boolean;
    /** Without access, show only the locked link: no "upgrade… Contact us" line under it (the page offers it elsewhere). */
    hideAccessMessage?: boolean;
    onClick?: () => void;
    onContactUsClick?: () => void;
}> = ({
    url,
    text,
    altText,
    hasAccess = true,
    hideArrowIcon,
    hideAccessMessage,
    onContactUsClick,
    className,
    style,
    testId,
    onClick,
}) => {
    const [isRequestSent, setIsRequestSent] = useState(false);

    const buttonProps = useMemo(
        () => ({
            className: cn(
                "AccessLink__anchor",
                !hasAccess && "is-disabled"
            ),
            onClick,
            children: (<>
                {text}
                {!hideArrowIcon && (
                    <IoIosArrowForward className="AccessLink__icon" />
                )}
            </>),
        }),
        [hasAccess, onClick, text, hideArrowIcon]
    );

    return (
        <div
            className={cn('AccessLink', className)}
            style={style}
            data-testid={testId}
        >
            {isRequestSent && (<>
                Thank you for your request, we will get back to you shortly!
            </>)}
            {!isRequestSent && (<>
                {!hasAccess && <FaLock style={{ transform: 'translate(-3px, 2px)' }} />}
                &nbsp;
                {url === null ? (
                    <button {...buttonProps} />
                ) : (
                    <a
                        href={url}
                        target="_blank"
                        rel="noreferrer"
                        {...buttonProps}
                    >
                        {buttonProps.children}
                    </a>
                )}
                {!hideAccessMessage && <br />}
                {!hasAccess && !hideAccessMessage && (<>
                    {altText ?? text}
                    {onContactUsClick && (<>
                        &nbsp;<button
                            className="AccessLink__anchor is-underlined"
                            onClick={(e) => {
                                e.preventDefault();
                                onContactUsClick();
                                setIsRequestSent(true);
                            }}
                        >
                            Contact us
                        </button>
                        &nbsp;to learn more
                    </>)}
                </>)}
            </>)}
        </div>
    );
};

export default AccessLink;
